export enum AnalysisSource {
  Nexus,
  Insight,
  RetailMatch,
  Buxton
}
